<template>
  <nav class="navbar navbar-expand-lg " :class="'bg-'+theme">
    <div class="container-fluid d-flex">
      <!---|‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
      | Burger-lines Button
      |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒!-->
      <button
        class="btn btn-outline btn-round btn-icon d-none d-lg-block"
        :class="'btn-'+theme"
        @click="minimizeSidebar"
      >
        <i :class="$sidebar.isMinimized ? 'fa fa-ellipsis-v' : 'fa fa-ellipsis-v'"></i>
      </button>

      <!---|‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
      | Burger-lines Button Mobile
      |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒!-->
      <button
        type="button"
        class="navbar-toggler navbar-toggler-right"
        :class="{toggled: $sidebar.showSidebar}"
        aria-expanded="false"
        @click="toggleSidebar"
      >
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <!---|‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
      | Brand
      |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒!-->
      <a class="navbar-brand" :class="'main-'+theme">{{this.$route.name}}</a>

      <!---|‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
      | Notifications Button Mobile
      |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒!-->
      <div class="justify-content-end d-block d-sm-none">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" href="/notices">
              <i class="fas fa-bell"></i>
              <span
                class="notification"
                v-if="notReadNotifications.length"
              >{{notReadNotifications.length}}</span>
            </a>
            <a class="nav-link" >
              <span @click="modals.centered = true" v-if="$auth.user().plan_type_code == 'PREMIUM' || $auth.user().plan_type_code == 'PREMIUM_REMATRICULA' || $auth.user().plan_type_code == 'PLUS'">
              <router-link to="/faq" href="/faq">
                <i class="fas fa-question-circle" style="font-size: 1.4em; cursor: pointer;"></i>
              </router-link>
              </span>
              <span v-else>
                <router-link to="/sac" href="/sac" class="text-white">
                  <i class="fas fa-question-circle" style="font-size: 1.4em; cursor: pointer;"></i>
                </router-link>
              </span>
            </a>
          </li>
        </ul>
      </div>
      <!---|‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
      | Notifications Button
      |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒!-->
      <div class="row align-items-center">
          <div class="text-center d-none d-sm-block">
            <span @click="modals.centered = true"  v-if="$auth.user().plan_type_code == 'PREMIUM' || $auth.user().plan_type_code == 'PREMIUM_REMATRICULA' || $auth.user().plan_type_code == 'PLUS'"  >
              <router-link to="/faq" href="/faq" :class="'main-'+theme">Suporte ao Aluno
                <i class="fas fa-question-circle" style="font-size: 1.4em; cursor: pointer;"></i>
              </router-link>
            </span>
            <span v-else>
              <router-link to="/sac" href="/sac" :class="'main-'+theme">Suporte ao Aluno
                <i class="fas fa-question-circle" style="font-size: 1.4em; cursor: pointer;"></i>
              </router-link>
            </span>
          </div>
        <div class="justify-content-end d-none d-sm-block" style="position:relative;top:-1px;">
          <ul class="navbar-nav">
            <drop-down position="right">
              <template slot="title">
                  <!-- <i class="nc-icon nc-bell-55"></i> -->
                  <span :style="this.$auth.user().layout === 'light' ? 'color: #002c42;' : 'color: #ffb33b;'">
                    <i class="fas fa-bell"></i>
                  </span>
                  <span
                    class="notification"
                    v-if="notReadNotifications.length"
                    >{{notReadNotifications.length}}
                  </span>
              </template>
              <a
                class="dropdown-item"
                href="#"
                v-for="(notReadNotification, index) in notReadNotifications"
                :key="notReadNotification.id"
                @click.prevent="updateReadNotification(notReadNotification, index)"
              >{{ notReadNotification.subject }}</a>
              <a class="dropdown-item" href="#" v-if="noNotification">{{noNotification}}</a>
            </drop-down>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import swal from "sweetalert2";
import Vue from "vue";
import { Dialog, Table, TableColumn, MessageBox } from "element-ui";
export default {
  components: {
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    routeName() {
      return this.capitalizeFirstLetter(name);
      const { name } = this.$route;
    },
    theme() {
      return this.$auth.user().layout;
    }
  },
  data() {
    return {
      modals: {
        centered: false
      },
      modal: false,
      activeNotifications: false,
      notReadNotifications: [],
      noNotification: "",
      timer: ""
    };
  },
  methods: {
    showSwal() {
      swal({
        title: `Here's a message!`,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill"
      });
    },
    openModal(centered) {
      this.modals[centered] = true;
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    closeModal(centered) {
      this.modals[centered] = false;
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },
    fetchNotReadNotifications() {
      this.axios
        .get("/notreadnotices")
        .then(response => {
          // console.log(response.data.data);
          if (response.data.data) {
            this.noNotification = "";
            this.notReadNotifications = response.data.data;
            this.$notify({
              message: "Você possui Notificações de Avisos não lidas.",
              icon: "nc-icon nc-bell-55",
              type: "danger",
              horizontalAlign: "center"
            });
          } else {
            this.noNotification = "Nenhuma nova notificação.";
          }
        })
        .catch(error => {
          console.log(error);
          alert(
            "Erro ao carregar notificações. Recarregue a página. \n" + error
          );
        });
    },
    updateReadNotification(notReadNotification, index) {
      this.notReadNotifications.splice(index, 1);
      if (this.notReadNotifications.length === 0) {
        this.noNotification = "Nenhuma nova notificação.";
      }
      var messageId = { message_id: notReadNotification.id };
      this.axios
        .patch("/updatereadnotice", messageId)
        .then(response => {
          this.$router.push("/notices");
        })
        .catch(error => {
          console.log(error);
          alert(
            "Erro ao carregar notificações. Recarregue a página. \n" + error
          );
        });
    }
  },
  created() {
    this.fetchNotReadNotifications();
    this.timer = setInterval(this.fetchNotReadNotifications, 3600000);
  }
};
</script>
<style>
.btn-black {
  background-color: #eeecec !important;
  color: #03141e !important;
}
.btn-light {
  background-color: #002c42 !important;
  color: #eeecec !important;
}
.bg-black {
  background-color: #0b0c0d !important;
  color: #d8d8d8 !important;
}
.bg-light {
  background-color: #d8d8d8 !important;
  color: #03141e !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/TopNavbar.vue